import Markdown from "react-markdown";

/** Renders a committed legal markdown doc as a clean, readable page. Content is
 * rendered verbatim — placeholders like [EFFECTIVE DATE] are intentional. */
export function LegalDoc({ markdown }: { markdown: string }) {
  return (
    <section className="section">
      <div className="container">
        <article className="prose">
          <Markdown>{markdown}</Markdown>
        </article>
      </div>
    </section>
  );
}
